(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yg-footer')) {
    class YGFooter extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        cancelAnimationFrame(this.setupFrame);
        this.setupFrame = requestAnimationFrame(() => {
          if (this.isConnected) this.initialize();
        });
      }

      initialize() {
        this.abortController = new AbortController();
        this.items = Array.from(this.querySelectorAll('.yg-footer__item'));
        this.closeTimers = new Map();
        this.nativeStates = new WeakMap();
        this.rotations = new WeakMap();
        this.mobileQuery = matchMedia('(max-width: 767.98px)');
        this.mobileOpenItem = this.items[0] || null;
        this.duration = parseFloat(getComputedStyle(this).getPropertyValue('--yg-footer-duration')) || 400;
        const { signal } = this.abortController;

        this.updateLayout();
        this.mobileQuery.addEventListener('change', this.updateLayout, { signal });
        this.addEventListener('click', this.handleClick, { signal });
        this.addEventListener('toggle', this.handleToggle, { capture: true, signal });
        this.addEventListener('transitionend', this.handleTransitionEnd, { signal });
        this.addEventListener('shopify:block:select', this.handleBlockSelect, { signal });
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.setupFrame);
        this.abortController?.abort();
        this.closeTimers?.forEach((timer) => clearTimeout(timer));
        this.closeTimers?.clear();
      }

      updateLayout = () => {
        this.items.forEach((item) => {
          clearTimeout(this.closeTimers.get(item));
          const expanded = !this.mobileQuery.matches || item === this.mobileOpenItem;
          const summary = item.querySelector('.yg-footer__summary');
          const panel = item.querySelector('.yg-footer__panel');
          this.nativeStates.set(item, expanded);
          item.open = expanded;
          item.classList.remove('is-closing');
          summary.setAttribute('aria-expanded', String(expanded));
          summary.tabIndex = this.mobileQuery.matches ? 0 : -1;
          panel.inert = !expanded;
          panel.setAttribute('aria-hidden', String(!expanded));
          item.querySelector('.yg-footer__toggle-icon').style.removeProperty('--yg-footer-icon-rotation');
          this.rotations.delete(item);
        });
        this.closeTimers.clear();
      };

      setOpenItem(activeItem) {
        this.mobileOpenItem = activeItem;
        this.items.forEach((item) => this.setExpanded(item, item === activeItem));
      }

      setExpanded(item, expanded, animate = true) {
        const summary = item.querySelector('.yg-footer__summary');
        if ((summary.getAttribute('aria-expanded') === 'true') === expanded) return;

        clearTimeout(this.closeTimers.get(item));
        this.closeTimers.delete(item);
        const panel = item.querySelector('.yg-footer__panel');
        summary.setAttribute('aria-expanded', String(expanded));
        panel.inert = !expanded;
        panel.setAttribute('aria-hidden', String(!expanded));

        if (!animate || matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.nativeStates.set(item, expanded);
          item.open = expanded;
          item.classList.remove('is-closing');
          return;
        }

        const rotation = (this.rotations.get(item) || 0) + 360;
        this.rotations.set(item, rotation);
        item.querySelector('.yg-footer__toggle-icon').style.setProperty('--yg-footer-icon-rotation', `${rotation}deg`);

        if (expanded) {
          if (!item.open) {
            item.classList.add('is-closing');
            this.nativeStates.set(item, true);
            item.open = true;
            panel.getBoundingClientRect();
          }
          item.classList.remove('is-closing');
        } else {
          item.classList.add('is-closing');
          this.closeTimers.set(
            item,
            setTimeout(() => this.finishClosing(item), this.duration + 50)
          );
        }
      }

      finishClosing(item) {
        if (!item.classList.contains('is-closing')) return;
        clearTimeout(this.closeTimers.get(item));
        this.closeTimers.delete(item);
        this.nativeStates.set(item, false);
        item.open = false;
        item.classList.remove('is-closing');
      }

      handleClick = (event) => {
        const summary = event.target.closest('.yg-footer__summary');
        if (!summary || summary.closest('yg-footer') !== this || event.defaultPrevented) return;
        event.preventDefault();
        if (!this.mobileQuery.matches) return;
        this.setOpenItem(summary.getAttribute('aria-expanded') === 'true' ? null : summary.closest('.yg-footer__item'));
      };

      handleToggle = (event) => {
        const item = event.target;
        if (!this.items.includes(item) || item.open === this.nativeStates.get(item)) return;
        this.nativeStates.set(item, item.open);
        if (!this.mobileQuery.matches) {
          this.updateLayout();
        } else if (item.open) {
          this.setOpenItem(item);
        } else {
          if (this.mobileOpenItem === item) this.mobileOpenItem = null;
          this.setExpanded(item, false, false);
        }
      };

      handleTransitionEnd = (event) => {
        if (event.propertyName !== 'grid-template-rows' || !event.target.matches('.yg-footer__panel')) return;
        const item = event.target.closest('.yg-footer__item');
        if (this.items.includes(item)) this.finishClosing(item);
      };

      handleBlockSelect = (event) => {
        if (!this.mobileQuery.matches) return;
        const item = event.target.closest('.yg-footer__item');
        if (this.items.includes(item)) this.setOpenItem(item);
      };
    }

    customElements.define('yg-footer', YGFooter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-email"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yg-email')) {
    class YGEmail extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        this.form = this.querySelector('.yg-email__form');
        this.checkbox = this.querySelector('.yg-email__checkbox');
        this.consentError = this.querySelector('.yg-email__consent-error');
        this.submitButton = this.querySelector('.yg-email__button');
        if (!this.form || !this.checkbox || !this.consentError) return;

        const { signal } = this.abortController;
        this.resetSubmitting();
        this.updateConsent();
        this.form.addEventListener('click', this.handleAttempt, { signal });
        this.form.addEventListener('keydown', this.handleAttempt, { signal });
        this.form.addEventListener('submit', this.handleSubmit, { signal });
        this.form.addEventListener('invalid', this.handleInvalid, { capture: true, signal });
        this.checkbox.addEventListener('change', this.updateConsent, { signal });
        this.querySelector('.yg-email__consent-text')?.addEventListener('click', this.handleConsentClick, { signal });
        window.addEventListener('pageshow', this.resetSubmitting, { signal });
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      setSubmitting(submitting) {
        this.isSubmitting = submitting;
        this.submitButton?.setAttribute('aria-busy', String(submitting));
        this.submitButton?.setAttribute('aria-disabled', String(submitting));
      }

      resetSubmitting = () => {
        this.setSubmitting(false);
      };

      handleConsentClick = (event) => {
        if (event.defaultPrevented || event.target.closest('a')) return;
        this.checkbox.click();
        this.checkbox.focus();
      };

      updateConsent = () => {
        this.checkbox.setCustomValidity(this.checkbox.checked ? '' : this.dataset.consentError || '');
        if (this.checkbox.checked) {
          this.checkbox.removeAttribute('aria-invalid');
          this.consentError.hidden = true;
        }
      };

      showConsentError() {
        this.consentError.hidden = false;
        this.checkbox.setAttribute('aria-invalid', 'true');
        this.checkbox.focus();
      }

      handleAttempt = (event) => {
        const clickedSubmit = event.type === 'click' && event.target.closest('button[type="submit"]');
        const pressedEnter =
          event.type === 'keydown' &&
          event.key === 'Enter' &&
          !event.isComposing &&
          event.target.matches('.yg-email__input');
        if (event.defaultPrevented || (!clickedSubmit && !pressedEnter)) return;
        if (this.isSubmitting) {
          event.preventDefault();
          return;
        }
        if (this.checkbox.checked) return;
        event.preventDefault();
        this.showConsentError();
      };

      handleSubmit = (event) => {
        if (event.defaultPrevented) return;
        if (this.isSubmitting) {
          event.preventDefault();
          return;
        }
        if (!this.checkbox.checked) {
          event.preventDefault();
          this.showConsentError();
          return;
        }
        this.setSubmitting(true);
        queueMicrotask(() => {
          if (event.defaultPrevented) this.resetSubmitting();
        });
      };

      handleInvalid = (event) => {
        if (event.target === this.checkbox) this.showConsentError();
      };
    }

    customElements.define('yg-email', YGEmail);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yg-faq')) {
    class YGFAQ extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        this.closeTimers = new Map();
        this.nativeStates = new WeakMap();
        this.rotations = new WeakMap();
        this.duration = parseFloat(getComputedStyle(this).getPropertyValue('--yg-faq-duration')) || 400;
        const { signal } = this.abortController;

        this.querySelectorAll('.yg-faq__item').forEach((item) => {
          item.removeAttribute('name');
          item.classList.remove('is-closing');
          item.querySelector('.yg-faq__question').setAttribute('aria-expanded', String(item.open));
          const panel = item.querySelector('.yg-faq__answer-panel');
          panel.inert = !item.open;
          panel.setAttribute('aria-hidden', String(!item.open));
          item.querySelector('.yg-faq__icon-rotator').style.removeProperty('--yg-faq-icon-rotation');
          this.nativeStates.set(item, item.open);
        });

        this.addEventListener('click', this.handleClick, { signal });
        this.addEventListener('toggle', this.handleToggle, { capture: true, signal });
        this.addEventListener('transitionend', this.handleTransitionEnd, { signal });
        this.addEventListener('shopify:block:select', this.handleBlockSelect, { signal });
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.closeTimers.forEach((timer, item) => {
          clearTimeout(timer);
          item.open = item.querySelector('.yg-faq__question').getAttribute('aria-expanded') === 'true';
          item.classList.remove('is-closing');
        });
        this.closeTimers.clear();
      }

      setOpenItem(activeItem) {
        this.querySelectorAll('.yg-faq__item').forEach((item) => {
          this.setExpanded(item, item === activeItem);
        });
      }

      setExpanded(item, expanded, animate = true) {
        const summary = item.querySelector('.yg-faq__question');
        if ((summary.getAttribute('aria-expanded') === 'true') === expanded) return;

        clearTimeout(this.closeTimers.get(item));
        this.closeTimers.delete(item);
        const panel = item.querySelector('.yg-faq__answer-panel');
        const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
        summary.setAttribute('aria-expanded', String(expanded));
        panel.inert = !expanded;
        panel.setAttribute('aria-hidden', String(!expanded));

        if (!animate || reducedMotion) {
          this.nativeStates.set(item, expanded);
          item.open = expanded;
          item.classList.remove('is-closing');
          return;
        }

        const rotation = (this.rotations.get(item) || 0) + 360;
        this.rotations.set(item, rotation);
        item.querySelector('.yg-faq__icon-rotator').style.setProperty('--yg-faq-icon-rotation', `${rotation}deg`);

        if (expanded) {
          if (!item.open) {
            item.classList.add('is-closing');
            this.nativeStates.set(item, true);
            item.open = true;
            panel.getBoundingClientRect();
          }
          item.classList.remove('is-closing');
        } else {
          item.classList.add('is-closing');
          this.closeTimers.set(
            item,
            setTimeout(() => this.finishClosing(item), this.duration + 50)
          );
        }
      }

      finishClosing(item) {
        if (!item.classList.contains('is-closing')) return;
        clearTimeout(this.closeTimers.get(item));
        this.closeTimers.delete(item);
        this.nativeStates.set(item, false);
        item.open = false;
        item.classList.remove('is-closing');
      }

      handleClick = (event) => {
        const summary = event.target.closest('.yg-faq__question');
        if (!summary || summary.closest('yg-faq') !== this || event.defaultPrevented) return;

        event.preventDefault();
        const item = summary.closest('.yg-faq__item');
        this.setOpenItem(summary.getAttribute('aria-expanded') === 'true' ? null : item);
      };

      handleToggle = (event) => {
        const item = event.target;
        if (!item.matches('.yg-faq__item') || item.closest('yg-faq') !== this) return;
        if (item.open === this.nativeStates.get(item)) return;

        this.nativeStates.set(item, item.open);
        if (item.open) {
          this.setOpenItem(item);
        } else {
          this.setExpanded(item, false, false);
        }
      };

      handleTransitionEnd = (event) => {
        if (event.propertyName !== 'grid-template-rows' || !event.target.matches('.yg-faq__answer-panel')) return;
        const item = event.target.closest('.yg-faq__item');
        if (item.closest('yg-faq') === this) this.finishClosing(item);
      };

      handleBlockSelect = (event) => {
        const item = event.target.closest('.yg-faq__item');
        if (item && item.closest('yg-faq') === this) {
          this.setOpenItem(item);
        }
      };
    }

    customElements.define('yg-faq', YGFAQ);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-floating-cta"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yg-floating-cta')) {
    class YGFloatingCTA extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.section = this.closest('.shopify-section');
        if (!this.section || !this.closest('#MainContent')) return;

        this.abortController = new AbortController();
        this.preview = false;
        const { signal } = this.abortController;
        if (this.hasAttribute('data-design-mode')) {
          document.addEventListener('shopify:section:select', this.handleSelect, { signal });
          document.addEventListener('shopify:section:deselect', this.handleDeselect, { signal });
        }

        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.initialize();
        });
      }

      initialize() {
        this.button = this.button || this.querySelector('.yg-floating-cta__button');
        if (!this.button) return;
        this.setVisible(false);
        document.body.appendChild(this.button);

        const { signal } = this.abortController;
        this.button.addEventListener('click', this.handleClick, { signal });
        window.addEventListener('scroll', this.scheduleUpdate, { passive: true, signal });
        window.addEventListener('resize', this.scheduleUpdate, { signal });
        window.addEventListener('pageshow', this.scheduleUpdate, { signal });
        window.addEventListener('load', this.scheduleUpdate, { signal });
        window.visualViewport?.addEventListener('resize', this.scheduleUpdate, { signal });

        this.resizeObserver = new ResizeObserver(this.scheduleUpdate);
        this.resizeObserver.observe(document.body);
        this.resizeObserver.observe(document.documentElement);
        this.mutationObserver = new MutationObserver(this.scheduleUpdate);
        this.mutationObserver.observe(document.getElementById('MainContent'), { childList: true, subtree: true });

        this.scheduleUpdate();
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.abortController = null;
        this.resizeObserver?.disconnect();
        this.mutationObserver?.disconnect();
        cancelAnimationFrame(this.frame);
        this.frame = null;
        this.preview = false;
        this.setVisible(false);
        this.button?.remove();
      }

      getTarget() {
        return this.dataset.targetId ? document.getElementById(this.dataset.targetId) : null;
      }

      scheduleUpdate = () => {
        if (!this.abortController || this.frame != null) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          const viewportHeight = window.innerHeight;
          const scrollTop = Math.max(0, window.scrollY);
          const remaining = document.scrollingElement.scrollHeight - viewportHeight - scrollTop;
          const target = this.getTarget();
          const targetBounds = target?.getBoundingClientRect();
          const targetHeightInView = targetBounds
            ? Math.max(0, Math.min(targetBounds.bottom, viewportHeight) - Math.max(targetBounds.top, 0))
            : 0;
          const visible = Boolean(target?.getClientRects().length) &&
            scrollTop > 0 && remaining > viewportHeight &&
            targetHeightInView < viewportHeight * 0.3;
          this.setVisible(this.preview || visible);
        });
      };

      setVisible(visible) {
        if (!this.button) return;
        if (!visible && document.activeElement === this.button) this.button.blur();
        this.button.inert = !visible;
        this.button.setAttribute('aria-hidden', String(!visible));
        if (visible) this.button.removeAttribute('tabindex');
        else this.button.setAttribute('tabindex', '-1');
        this.button.toggleAttribute('data-visible', visible);
      }

      handleClick = (event) => {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const target = this.getTarget();
        if (!target) {
          event.preventDefault();
          this.scheduleUpdate();
          return;
        }

        event.preventDefault();
        const destination = target.closest('.yg-form-builder-section') || target;
        const header = document.querySelector('header[is="sticky-header"]');
        const headerHeight = header
          ? parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || header.offsetHeight
          : 0;
        const localnav = document.querySelector('yg-localnav[data-visible]');
        const offset = Math.max(96, headerHeight + 16, localnav ? localnav.getBoundingClientRect().bottom + 16 : 0);
        const top = Math.max(0, destination.getBoundingClientRect().top + window.scrollY - offset);
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (!target.hasAttribute('tabindex')) {
          target.setAttribute('tabindex', '-1');
          target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
        }
        target.focus({ preventScroll: true });
        window.scrollTo({ top, behavior: reduceMotion ? 'instant' : 'smooth' });
      };

      handleSelect = (event) => {
        if (event.target !== this.section && event.detail?.sectionId !== this.dataset.sectionId) return;
        this.preview = true;
        this.scheduleUpdate();
      };

      handleDeselect = (event) => {
        if (event.target !== this.section && event.detail?.sectionId !== this.dataset.sectionId) return;
        this.preview = false;
        this.scheduleUpdate();
      };
    }

    customElements.define('yg-floating-cta', YGFloatingCTA);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-image-automatic-swiper"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yg-image-automatic-swiper')) {
    class YGImageAutomaticSwiper extends HTMLElement {
      static modulePromise;

      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        this.originalSlides = Array.from(this.querySelectorAll('.yg-image-automatic-swiper__slide:not([data-copy])'));
        this.selectedBlockId = null;
        const { signal } = this.abortController;

        this.addEventListener('shopify:block:select', this.handleBlockSelect, { signal });
        this.addEventListener('shopify:block:deselect', this.handleBlockDeselect, { signal });
        this.loadImages(this.originalSlides.slice(0, 3));

        if (this.originalSlides.length > 1) this.initialize(signal);
      }

      disconnectedCallback() {
        this.abortController?.abort();
        cancelAnimationFrame(this.resizeFrame);
        this.swiper?.destroy(true, true);
        this.swiper = null;
        this.querySelectorAll('[data-copy]').forEach((slide) => slide.remove());
        const wrapper = this.querySelector('.swiper-wrapper');
        this.originalSlides?.forEach((slide) => wrapper.append(slide));
        this.querySelectorAll('.yg-image-automatic-swiper__slide').forEach((slide) =>
          slide.removeAttribute('aria-hidden')
        );
      }

      async initialize(signal) {
        try {
          YGImageAutomaticSwiper.modulePromise ||= import('@theme/swiper');
          const { Swiper, Autoplay } = await YGImageAutomaticSwiper.modulePromise;
          if (signal.aborted || !this.isConnected) return;

          const wrapper = this.querySelector('.swiper-wrapper');
          while (wrapper.children.length < 6) {
            this.originalSlides.forEach((slide) => {
              const copy = slide.cloneNode(true);
              copy.dataset.copy = '';
              [copy, ...copy.querySelectorAll('*')].forEach((node) => {
                node.removeAttribute('id');
                Array.from(node.attributes).forEach((attribute) => {
                  if (attribute.name.startsWith('data-shopify-')) node.removeAttribute(attribute.name);
                });
              });
              wrapper.append(copy);
            });
          }

          const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
          const transitionSpeed = reducedMotion ? 0 : Number(this.dataset.transitionSpeed ?? 500);
          this.swiper = new Swiper(this.querySelector('.yg-image-automatic-swiper__viewport'), {
            modules: [Autoplay],
            slidesPerView: 1,
            spaceBetween: 14,
            breakpoints: {
              768: {
                slidesPerView: 2,
                spaceBetween: 16,
              },
            },
            speed: transitionSpeed,
            loop: true,
            loopAdditionalSlides: 1,
            watchSlidesProgress: true,
            autoplay: {
              delay: Number(this.dataset.autoplayDelay ?? 5000),
              disableOnInteraction: false,
              pauseOnMouseEnter: false,
              waitForTransition: transitionSpeed > 0,
            },
            on: {
              init: (swiper) => this.syncLoop(swiper),
              slideChange: (swiper) => this.syncSlides(swiper),
              resize: (swiper) => {
                cancelAnimationFrame(this.resizeFrame);
                this.resizeFrame = requestAnimationFrame(() => {
                  if (this.isConnected && !swiper.destroyed) this.syncLoop(swiper);
                });
              },
              transitionEnd: (swiper) => {
                this.syncSlides(swiper);
                if (this.selectedBlockId) swiper.autoplay.stop();
              },
            },
          });

          if (this.selectedBlockId) this.selectBlock(this.selectedBlockId);
        } catch (error) {
          YGImageAutomaticSwiper.modulePromise = null;
          if (!signal.aborted) console.error('YG automatic image swiper could not initialize.', error);
        }
      }

      loadImages(slides) {
        slides.forEach((slide) => {
          slide.querySelectorAll('img[data-src]').forEach((image) => {
            image.src = image.dataset.src;
            image.removeAttribute('data-src');
          });
        });
      }

      syncLoop(swiper) {
        swiper.loopFix();
        this.syncSlides(swiper);
        if (!this.selectedBlockId && swiper.autoplay.running && swiper.autoplay.paused) {
          swiper.autoplay.resume();
        }
      }

      syncSlides(swiper) {
        const slides = Array.from(swiper.slides);
        const visibleCount = Number(swiper.params.slidesPerView);
        const nearby = [];
        slides.forEach((slide, index) => {
          const offset = (index - swiper.activeIndex + slides.length) % slides.length;
          const visible = offset < visibleCount || offset === slides.length - 1 || offset === visibleCount;
          slide.setAttribute('aria-hidden', String(!visible));
          if (offset <= visibleCount + 1 || offset >= slides.length - 2) nearby.push(slide);
        });
        this.loadImages(nearby);
      }

      selectBlock(blockId) {
        if (!this.swiper) return;
        const slide = this.originalSlides.find((item) => item.dataset.blockId === blockId);
        if (!slide) return;
        this.swiper.autoplay.stop();
        this.swiper.slideToLoop(Number(slide.dataset.swiperSlideIndex), 0);
      }

      handleBlockSelect = (event) => {
        const slide = event.target.closest('.yg-image-automatic-swiper__slide');
        if (!slide || slide.closest('yg-image-automatic-swiper') !== this) return;
        this.selectedBlockId = slide.dataset.blockId;
        this.selectBlock(this.selectedBlockId);
      };

      handleBlockDeselect = (event) => {
        const slide = event.target.closest('.yg-image-automatic-swiper__slide');
        if (!slide || slide.closest('yg-image-automatic-swiper') !== this) return;
        this.selectedBlockId = null;
        if (this.swiper && !this.swiper.autoplay.running) this.swiper.autoplay.start();
      };
    }

    customElements.define('yg-image-automatic-swiper', YGImageAutomaticSwiper);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-image-swiper"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yg-image-swiper')) {
    class YGImageSwiper extends HTMLElement {
      static modulePromise;

      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        this.slides = Array.from(this.querySelectorAll('.yg-image-swiper__slide'));
        this.dots = Array.from(this.querySelectorAll('.yg-image-swiper__dot'));
        this.autoplayEnabled = this.dataset.autoplay === 'true' && this.slides.length > 1;
        this.selectedBlockId = null;
        const { signal } = this.abortController;

        this.addEventListener('click', this.handleClick, { signal });
        this.addEventListener('load', this.handleImageLoad, { capture: true, signal });
        this.addEventListener('shopify:block:select', this.handleBlockSelect, { signal });
        this.addEventListener('shopify:block:deselect', this.handleBlockDeselect, { signal });
        this.initialize(signal);
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.swiper?.destroy(true, true);
        this.swiper = null;
        delete this.dataset.ready;
      }

      async initialize(signal) {
        try {
          YGImageSwiper.modulePromise ||= import('@theme/swiper');
          const { Swiper, Navigation, Autoplay } = await YGImageSwiper.modulePromise;
          if (signal.aborted || !this.isConnected) return;
          const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

          this.swiper = new Swiper(this.querySelector('.yg-image-swiper__viewport'), {
            modules: [Navigation, Autoplay],
            slidesPerView: 1,
            spaceBetween: 0,
            speed: reducedMotion ? 0 : 500,
            loop: this.slides.length > 1,
            autoHeight: true,
            watchOverflow: true,
            navigation: {
              prevEl: this.querySelector('.yg-image-swiper__arrow--previous'),
              nextEl: this.querySelector('.yg-image-swiper__arrow--next'),
            },
            autoplay: this.autoplayEnabled
              ? {
                  delay: Number(this.dataset.autoplayDelay) || 5000,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: false,
                  waitForTransition: !reducedMotion,
                }
              : false,
            on: {
              init: (swiper) => this.syncSlide(swiper),
              realIndexChange: (swiper) => this.syncSlide(swiper),
              autoplayTimeLeft: (swiper, timeLeft, remaining) => {
                if (swiper.animating || swiper.autoplay.paused || this.selectedBlockId) return;
                const progress = Math.max(0, Math.min(1, 1 - remaining));
                this.dots[swiper.realIndex]?.style.setProperty('--yg-image-swiper-progress', String(progress));
              },
              transitionEnd: (swiper) => {
                swiper.updateAutoHeight();
                if (this.selectedBlockId) swiper.autoplay.stop();
              },
            },
          });

          this.dataset.ready = '';
          if (this.selectedBlockId) this.selectBlock(this.selectedBlockId);
        } catch (error) {
          YGImageSwiper.modulePromise = null;
          if (!signal.aborted) console.error('YG image swiper could not initialize.', error);
        }
      }

      syncSlide(swiper) {
        this.dots.forEach((dot, index) => {
          const active = index === swiper.realIndex;
          dot.classList.toggle('is-active', active);
          dot.style.setProperty('--yg-image-swiper-progress', '0');
          if (active) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });

        this.slides.forEach((slide) => {
          slide.setAttribute('aria-hidden', String(Number(slide.dataset.slideIndex) !== swiper.realIndex));
        });

        const count = this.slides.length;
        [swiper.realIndex, (swiper.realIndex + 1) % count, (swiper.realIndex + count - 1) % count].forEach((index) => {
          this.slides[index]?.querySelectorAll('img[data-src]').forEach((image) => {
            image.src = image.dataset.src;
            image.removeAttribute('data-src');
          });
        });
      }

      selectBlock(blockId) {
        const slide = this.slides.find((item) => item.dataset.blockId === blockId);
        if (!slide || !this.swiper) return;
        this.swiper.autoplay.stop();
        const index = Number(slide.dataset.slideIndex);
        if (this.swiper.params.loop) {
          this.swiper.slideToLoop(index, 0);
        } else {
          this.swiper.slideTo(index, 0);
        }
      }

      handleClick = (event) => {
        const dot = event.target.closest('.yg-image-swiper__dot');
        if (!dot || dot.closest('yg-image-swiper') !== this || !this.swiper || this.swiper.animating) return;
        const index = Number(dot.dataset.slideIndex);
        if (index === this.swiper.realIndex) {
          if (this.autoplayEnabled && !this.selectedBlockId) {
            this.swiper.autoplay.stop();
            this.swiper.autoplay.start();
          }
          return;
        }
        this.swiper.slideToLoop(index);
      };

      handleImageLoad = () => {
        if (this.swiper && !this.swiper.destroyed) this.swiper.updateAutoHeight();
      };

      handleBlockSelect = (event) => {
        const slide = event.target.closest('.yg-image-swiper__slide');
        if (!slide || slide.closest('yg-image-swiper') !== this) return;
        this.selectedBlockId = slide.dataset.blockId;
        this.selectBlock(this.selectedBlockId);
      };

      handleBlockDeselect = (event) => {
        const slide = event.target.closest('.yg-image-swiper__slide');
        if (!slide || slide.closest('yg-image-swiper') !== this) return;
        this.selectedBlockId = null;
        if (this.autoplayEnabled && this.swiper && !this.swiper.autoplay.running) {
          this.swiper.autoplay.start();
        }
      };
    }

    customElements.define('yg-image-swiper', YGImageSwiper);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-localnav"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yg-localnav')) {
    class YGLocalnav extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.section = this.closest('.shopify-section');
        if (!this.section || !this.closest('#MainContent')) return;

        this.abortController = new AbortController();
        this.preview = false;
        const { signal } = this.abortController;
        window.addEventListener('scroll', this.scheduleUpdate, { passive: true, signal });
        window.addEventListener('resize', this.scheduleUpdate, { signal });
        window.addEventListener('pageshow', this.scheduleUpdate, { signal });
        window.addEventListener('load', this.scheduleUpdate, { signal });

        if (this.hasAttribute('data-design-mode')) {
          document.addEventListener('shopify:section:select', this.handleSelect, { signal });
          document.addEventListener('shopify:section:deselect', this.handleDeselect, { signal });
        }

        this.scheduleUpdate();
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.abortController = null;
        cancelAnimationFrame(this.frame);
        this.frame = null;
        this.preview = false;
        this.setVisible(false);
      }

      scheduleUpdate = () => {
        if (!this.abortController || this.frame != null) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          const pastFirstScreen = window.scrollY >= window.innerHeight;
          this.setVisible(this.preview || (this.hasAttribute('data-product-selected') && pastFirstScreen));
        });
      };

      setVisible(visible) {
        if (this.hasAttribute('data-visible') === visible) return;
        if (!visible && this.contains(document.activeElement)) document.activeElement.blur();
        this.inert = !visible;
        this.setAttribute('aria-hidden', String(!visible));
        this.toggleAttribute('data-visible', visible);
      }

      handleSelect = (event) => {
        if (event.target !== this.section && event.detail?.sectionId !== this.dataset.sectionId) return;
        this.preview = true;
        this.scheduleUpdate();
      };

      handleDeselect = (event) => {
        if (event.target !== this.section && event.detail?.sectionId !== this.dataset.sectionId) return;
        this.preview = false;
        this.scheduleUpdate();
      };
    }

    customElements.define('yg-localnav', YGLocalnav);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yg-slideshow')) {
    class YGSlideshow extends HTMLElement {
      static modulePromise;

      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const { signal } = this.abortController;
        this.slides = Array.from(this.querySelectorAll('.yg-slideshow__slide'));
        this.dots = Array.from(this.querySelectorAll('.yg-slideshow__dot'));
        this.mobileQuery = matchMedia('(max-width: 767.98px)');
        this.motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
        this.autoplayEnabled = this.dataset.autoplay === 'true' && this.slides.length > 1;
        this.selectedBlockId = null;
        this.visible = true;
        this.addEventListener('click', this.handleClick, { signal });
        this.addEventListener('load', this.updateHeight, { capture: true, signal });
        this.addEventListener('play', this.handleVideoPlay, { capture: true, signal });
        this.addEventListener('shopify:block:select', this.handleBlockSelect, { signal });
        this.addEventListener('shopify:block:deselect', this.handleBlockDeselect, { signal });
        this.mobileQuery.addEventListener('change', this.handleViewportChange, { signal });
        this.motionQuery.addEventListener('change', this.handleMotionChange, { signal });
        document.addEventListener('visibilitychange', this.syncMedia, { signal });
        this.resizeObserver = new ResizeObserver(this.updateHeight);
        this.slides.forEach((slide) => this.resizeObserver.observe(slide.querySelector('.yg-slideshow__media')));
        this.intersectionObserver = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting;
          this.syncMedia();
        });
        this.intersectionObserver.observe(this);
        this.initialize(signal);
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.querySelectorAll('video').forEach((video) => video.pause());
        this.swiper?.destroy(true, true);
        this.swiper = null;
        delete this.dataset.ready;
      }

      async initialize(signal) {
        try {
          YGSlideshow.modulePromise ||= import('@theme/swiper');
          const { Swiper, Navigation, Autoplay, EffectFade } = await YGSlideshow.modulePromise;
          if (signal.aborted || !this.isConnected) return;
          this.dataset.ready = '';
          this.swiper = new Swiper(this.querySelector('.yg-slideshow__viewport'), {
            modules: [Navigation, Autoplay, EffectFade],
            effect: this.dataset.effect === 'fade' ? 'fade' : 'slide',
            fadeEffect: { crossFade: true },
            slidesPerView: 1,
            spaceBetween: 0,
            speed: this.motionQuery.matches ? 0 : 500,
            loop: this.slides.length > 1,
            autoHeight: true,
            watchOverflow: true,
            navigation: {
              prevEl: this.querySelector('.yg-slideshow__arrow--previous'),
              nextEl: this.querySelector('.yg-slideshow__arrow--next'),
            },
            autoplay: this.autoplayEnabled
              ? {
                  delay: Number(this.dataset.autoplayDelay) || 5000,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: false,
                  waitForTransition: !this.motionQuery.matches,
                }
              : false,
            on: {
              init: (swiper) => this.syncSlide(swiper),
              realIndexChange: (swiper) => this.syncSlide(swiper),
              transitionEnd: (swiper) => {
                this.updateHeight();
                this.syncMedia();
                if (this.selectedBlockId) swiper.autoplay.stop();
                else if (this.autoplayEnabled && swiper.autoplay.running && swiper.autoplay.paused && !document.hidden)
                  swiper.autoplay.resume();
              },
              loopFix: () => this.syncMedia(),
              autoplayTimeLeft: (swiper, timeLeft, remaining) => {
                if (swiper.animating || swiper.autoplay.paused || this.selectedBlockId) return;
                this.dots[swiper.realIndex]?.style.setProperty(
                  '--yg-slideshow-progress',
                  String(Math.max(0, Math.min(1, 1 - remaining)))
                );
              },
            },
          });
          this.syncSlide(this.swiper);
          if (this.selectedBlockId) this.selectBlock(this.selectedBlockId);
        } catch (error) {
          YGSlideshow.modulePromise = null;
          delete this.dataset.ready;
          if (!signal.aborted) console.error('YG slideshow could not initialize.', error);
        }
      }

      get activeSlide() {
        return this.slides?.[this.swiper?.realIndex ?? 0];
      }

      syncSlide(swiper) {
        this.slides.forEach((slide) => {
          const active = Number(slide.dataset.slideIndex) === swiper.realIndex;
          slide.inert = !active;
          slide.setAttribute('aria-hidden', String(!active));
        });
        this.dots.forEach((dot, index) => {
          const active = index === swiper.realIndex;
          dot.classList.toggle('is-active', active);
          dot.style.setProperty('--yg-slideshow-progress', active && this.selectedBlockId ? '1' : '0');
          if (active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        this.syncControlColors();
        this.updateHeight();
        this.syncMedia();
        const count = this.slides.length;
        [swiper.realIndex, (swiper.realIndex + 1) % count, (swiper.realIndex + count - 1) % count].forEach((index) => {
          this.slides[index]?.querySelectorAll('img[data-src]').forEach((image) => {
            image.src = image.dataset.src;
            image.removeAttribute('data-src');
          });
        });
      }

      syncControlColors() {
        const active = this.slides.find((slide) => slide.getAttribute('aria-hidden') === 'false') || this.activeSlide;
        if (!active) return;
        const colors = getComputedStyle(active);
        ['arrow-color', 'arrow-background', 'dot-color', 'dot-active-color'].forEach((key) => {
          const property = `--yg-slideshow-${key}`;
          this.style.setProperty(property, colors.getPropertyValue(property).trim());
        });
      }

      updateHeight = () => {
        if (!this.isConnected) return;
        const active = this.slides?.find((slide) => slide.getAttribute('aria-hidden') === 'false') || this.activeSlide;
        const height = active?.querySelector('.yg-slideshow__media')?.getBoundingClientRect().height;
        if (height) this.style.setProperty('--yg-slideshow-media-height', `${height}px`);
        if (this.swiper && !this.swiper.destroyed) this.swiper.updateAutoHeight(0);
      };

      isActiveSlot(slot) {
        return (
          this.isConnected &&
          this.visible &&
          !document.hidden &&
          slot.closest('.yg-slideshow__slide') === this.activeSlide &&
          slot.classList.contains(
            this.mobileQuery.matches ? 'yg-slideshow__video-slot--mobile' : 'yg-slideshow__video-slot--desktop'
          )
        );
      }

      async loadVideo(slot) {
        if (slot.loadingVideo) return;
        slot.loadingVideo = true;
        const signal = this.abortController.signal;
        try {
          let video = slot.querySelector('video');
          if (!video) {
            const mediaTemplate = slot
              .querySelector('.yg-slideshow__video-template')
              .content.querySelector('deferred-media template');
            video = mediaTemplate?.content.querySelector('video')?.cloneNode(true);
            if (!video) return;
            video.removeAttribute('autoplay');
            slot.appendChild(video);
          }
          if (signal.aborted || !this.isActiveSlot(slot)) {
            video.pause();
            return;
          }
          video.muted = true;
          video.loop = true;
          video.playsInline = true;
          await video.play();
          if (signal.aborted || !this.isActiveSlot(slot)) video.pause();
          else slot.classList.add('is-loaded');
        } catch (error) {
          if (!signal.aborted && error.name !== 'NotAllowedError' && error.name !== 'AbortError')
            console.error('YG slideshow video could not play.', error);
        } finally {
          slot.loadingVideo = false;
        }
      }

      syncMedia = () => {
        if (!this.slides || this.abortController?.signal.aborted) return;
        this.querySelectorAll('.yg-slideshow__video-slot').forEach((slot) => {
          if (this.isActiveSlot(slot)) this.loadVideo(slot);
          else slot.querySelectorAll('video').forEach((video) => video.pause());
        });
      };

      handleVideoPlay = (event) => {
        const slot = event.target.closest('.yg-slideshow__video-slot');
        if (slot && !this.isActiveSlot(slot)) event.target.pause();
      };

      handleViewportChange = () => {
        this.syncControlColors();
        this.updateHeight();
        this.syncMedia();
      };

      handleMotionChange = () => {
        if (!this.swiper) return;
        this.swiper.params.speed = this.motionQuery.matches ? 0 : 500;
        this.swiper.params.autoplay.waitForTransition = !this.motionQuery.matches;
      };

      handleClick = (event) => {
        const dot = event.target.closest('.yg-slideshow__dot');
        if (!dot || dot.closest('yg-slideshow') !== this || !this.swiper || this.swiper.animating) return;
        const index = Number(dot.dataset.slideIndex);
        if (index === this.swiper.realIndex) {
          if (this.autoplayEnabled && !this.selectedBlockId) {
            this.swiper.autoplay.stop();
            this.swiper.autoplay.start();
            if (this.swiper.autoplay.paused) this.swiper.autoplay.resume();
          }
        } else this.swiper.slideToLoop(index);
      };

      selectBlock(blockId) {
        const slide = this.slides.find((item) => item.dataset.blockId === blockId);
        if (!slide || !this.swiper) return;
        this.swiper.autoplay.stop();
        const index = Number(slide.dataset.slideIndex);
        if (this.swiper.params.loop) this.swiper.slideToLoop(index, 0);
        else this.swiper.slideTo(index, 0);
        this.dots[index]?.style.setProperty('--yg-slideshow-progress', '1');
      }

      handleBlockSelect = (event) => {
        const slide = event.target.closest('.yg-slideshow__slide');
        if (!slide || slide.closest('yg-slideshow') !== this) return;
        this.selectedBlockId = slide.dataset.blockId;
        this.selectBlock(this.selectedBlockId);
      };

      handleBlockDeselect = (event) => {
        const slide = event.target.closest('.yg-slideshow__slide');
        if (!slide || slide.closest('yg-slideshow') !== this) return;
        this.selectedBlockId = null;
        if (this.autoplayEnabled && this.swiper) {
          this.swiper.autoplay.start();
          if (this.swiper.autoplay.paused) this.swiper.autoplay.resume();
        }
      };
    }
    customElements.define('yg-slideshow', YGSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yg-video-section')) {
    class YGVideoSection extends HTMLElement {
      get player() {
        return this.querySelector('yg-video');
      }

      get button() {
        return this.querySelector('.yg-video-section__play');
      }

      get container() {
        return this.player?.querySelector('.yg-video-iframe-container');
      }

      get video() {
        return this.container?.querySelector('video');
      }

      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        this.playAttempt = (this.playAttempt || 0) + 1;
        this.failedSources = new WeakSet();
        const { signal } = this.abortController;
        this.videoMediaQuery = window.matchMedia('(max-width: 767.98px)');

        this.addEventListener('click', this.handleClick, { capture: true, signal });
        this.addEventListener('playing', this.handlePlaying, { capture: true, signal });
        this.addEventListener('pause', this.handlePause, { capture: true, signal });
        this.addEventListener('ended', this.handleEnd, { capture: true, signal });
        this.addEventListener('error', this.handleError, { capture: true, signal });
        this.videoMediaQuery.addEventListener('change', this.handleViewportChange, { signal });

        customElements.whenDefined('yg-video').then(() => {
          if (!signal.aborted) this.player?.removeVideoMediaQueryListener?.();
        });
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.playAttempt += 1;
        this.player?.querySelectorAll('video').forEach((video) => video.pause());
        this.focusVideoOnPlay = false;
        this.setLoading(false);
      }

      setLoading(loading) {
        const media = this.querySelector('.yg-video-section__media');
        media?.classList.toggle('is-loading', loading);
        media?.setAttribute('aria-busy', String(loading));
        const spinner = this.querySelector('.yg-video-section__loading');
        if (spinner) spinner.hidden = !loading;
        if (this.button) this.button.disabled = loading;
      }

      handleClick = (event) => {
        const button = event.target.closest('.yg-video-section__play');
        if (!button || button !== this.button) return;

        event.preventDefault();
        event.stopPropagation();
        this.focusVideoOnPlay = document.activeElement === button;
        this.playCurrentVideo();
      };

      createVideo() {
        const player = this.player;
        const fragment = player?.querySelector('template')?.content.cloneNode(true);
        if (!fragment) return null;

        const videos = Array.from(fragment.querySelectorAll('video'));
        const mobileVideo = videos.find((video) => video.classList.contains('hide-pc'));
        const desktopVideo = videos.find((video) => !video.classList.contains('hide-pc'));
        const selected = this.videoMediaQuery.matches ? mobileVideo || desktopVideo : desktopVideo || mobileVideo;
        if (!selected) return null;

        videos.forEach((video) => {
          if (video !== selected) video.remove();
        });
        selected.removeAttribute('muted');
        selected.removeAttribute('autoplay');
        selected.muted = false;
        selected.defaultMuted = false;
        selected.controls = true;
        selected.playsInline = true;
        selected.preload = 'metadata';
        selected.tabIndex = 0;
        fragment.querySelector('.yg-video-iframe-container')?.classList.add('close');
        player.appendChild(fragment);
        return selected;
      }

      async playCurrentVideo() {
        const { signal } = this.abortController;
        const attempt = ++this.playAttempt;
        this.player?.removeVideoMediaQueryListener?.();
        this.setLoading(!this.player?.querySelector('.yg-video-placeholder')?.classList.contains('close'));
        try {
          const video = this.video || this.createVideo();
          if (!video) {
            this.resetPlayer();
            return;
          }

          await video.play();
        } catch {
          if (!signal.aborted && attempt === this.playAttempt) this.resetPlayer();
        }
      }

      handleViewportChange = () => {
        const container = this.container;
        if (!container) return;

        const wasClosed = container.classList.contains('close');
        const shouldResume =
          !this.video.paused || this.querySelector('.yg-video-section__media').classList.contains('is-loading');
        this.playAttempt += 1;
        container.querySelectorAll('video').forEach((video) => video.pause());
        container.remove();
        this.setLoading(false);

        if (shouldResume) {
          this.playCurrentVideo();
        } else if (!wasClosed) {
          this.createVideo();
          this.container?.classList.remove('close');
        }
      };

      handlePlaying = (event) => {
        const video = event.target;
        if (!video.matches('video') || video.closest('yg-video') !== this.player) return;

        this.container.classList.remove('close');
        this.player.querySelector('.yg-video-placeholder')?.classList.add('close');
        this.player.querySelector('.yg-video-button')?.classList.add('hide');
        this.setLoading(false);
        if (this.focusVideoOnPlay) video.focus({ preventScroll: true });
        this.focusVideoOnPlay = false;
      };

      handlePause = (event) => {
        if (event.target === this.video) this.setLoading(false);
      };

      resetPlayer() {
        this.playAttempt += 1;
        this.video?.pause();
        this.container?.remove();
        this.player?.querySelector('.yg-video-placeholder')?.classList.remove('close');
        this.player?.querySelector('.yg-video-button')?.classList.remove('hide');
        const shouldFocusButton = this.focusVideoOnPlay;
        this.focusVideoOnPlay = false;
        this.setLoading(false);
        if (shouldFocusButton) this.button?.focus({ preventScroll: true });
      }

      handleEnd = (event) => {
        if (event.target === this.video) this.resetPlayer();
      };

      handleError = (event) => {
        if (event.target === this.video) {
          this.resetPlayer();
          return;
        }

        const source = event.target;
        if (source.matches('source') && source.closest('video') === this.video) {
          this.failedSources.add(source);
          const sources = Array.from(this.video.querySelectorAll('source'));
          if (sources.every((item) => this.failedSources.has(item))) this.resetPlayer();
        }
      };
    }

    customElements.define('yg-video-section', YGVideoSection);
  }

  } catch(e) { console.error(e); }
})();
})();
